/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UboDeclarationBeneficiaryResource } from './';
import {
    UboDeclarationBeneficiaryResourceFromJSON,
    UboDeclarationBeneficiaryResourceFromJSONTyped,
    UboDeclarationBeneficiaryResourceToJSON,
} from './';
import type { UboDeclarationStatusResource } from './';
import {
    UboDeclarationStatusResourceFromJSON,
    UboDeclarationStatusResourceFromJSONTyped,
    UboDeclarationStatusResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboDeclarationResource
 */
export interface UboDeclarationResource {
    /**
     * 
     * @type {UboDeclarationStatusResource}
     * @memberof UboDeclarationResource
     */
    status: UboDeclarationStatusResource;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResource
     */
    refusalReason?: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResource
     */
    refusalReasonMessage?: string;
    /**
     * 
     * @type {Array<UboDeclarationBeneficiaryResource>}
     * @memberof UboDeclarationResource
     */
    ultimateBeneficialOwners: Array<UboDeclarationBeneficiaryResource>;
}

/**
 * Check if a given object implements the UboDeclarationResource interface.
 */
export function instanceOfUboDeclarationResource(value: object): value is UboDeclarationResource {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ultimateBeneficialOwners' in value) || value['ultimateBeneficialOwners'] === undefined) return false;
    return true;
}

export function UboDeclarationResourceFromJSON(json: any): UboDeclarationResource {
    return UboDeclarationResourceFromJSONTyped(json, false);
}

export function UboDeclarationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'status': UboDeclarationStatusResourceFromJSON(json['status']),
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
        'refusalReasonMessage': json['refusalReasonMessage'] == null ? undefined : json['refusalReasonMessage'],
        'ultimateBeneficialOwners': ((json['ultimateBeneficialOwners'] as Array<any>).map(UboDeclarationBeneficiaryResourceFromJSON)),
    };
}

export function UboDeclarationResourceToJSON(value?: UboDeclarationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': UboDeclarationStatusResourceToJSON(value['status']),
        'refusalReason': value['refusalReason'],
        'refusalReasonMessage': value['refusalReasonMessage'],
        'ultimateBeneficialOwners': ((value['ultimateBeneficialOwners'] as Array<any>).map((v) => UboDeclarationBeneficiaryResourceToJSON(v))),
    };
}

